import script from "./ChatSettingsWarningPoint.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSettingsWarningPoint.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSettingsWarningPoint.vue?vue&type=style&index=0&id=3a68ce93&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a68ce93"]])

export default __exports__